export default "__VITE_ASSET__BX_wT$vy__"